module.exports = __webpack_public_path__ + "img/issue-icon11.6b5529a.png";